import { Loader } from "@tfg/ui"
import { useEffect } from "react"
import { Navigate, Outlet, useNavigate } from "react-router-dom"

import { useAuth } from "~/store/auth-context"

export const AuthGuard = () => {
  const navigate = useNavigate()
  const { isAuthenticated, isLoading, user } = useAuth()

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login", { replace: true })
    }
  }, [isAuthenticated, user, navigate])

  if (isLoading) return <Loader fullPage />

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />
  }
  return <Outlet />
}
